module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "label-box"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.show_weixin = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-weixin",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 关注我们")]), _vm._v(" "), _c('label', {
    staticClass: "o"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$config.apibase + '/index.php/api/upload/downloadShortcuts'
    }
  }, [_vm._v("保存到桌面")])])]), _vm._v(" "), _c('div', {
    staticClass: "icons"
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-menu-box"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "router": true,
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/Newsflash"
    }
  }, [_vm._v("7x24h快讯")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/EconomicCalendar"
    }
  }, [_vm._v("财经日历")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/prediction"
    }
  }, [_vm._v("金汇预报")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/weekly"
    }
  }, [_vm._v("金汇周报")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/morningpaper"
    }
  }, [_vm._v("金汇早报")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/close"
    }
  }, [_vm._v("金汇内参")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/etfposition"
    }
  }, [_vm._v("ETF持仓")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/news"
    }
  }, [_vm._v("行业新闻")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/information_list/notice"
    }
  }, [_vm._v("金汇通知")])], 1)], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "top": "3%",
      "title": "扫码关注公众号",
      "size": "tiny",
      "modal-append-to-body": false,
      "visible": _vm.show_weixin
    },
    on: {
      "update:visible": function($event) {
        _vm.show_weixin = $event
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("./assets/images/qrcode_for_gh_3c0cf27cfbd1_430.jpg")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("扫码关注“每天都想看的资讯” ")])]), _vm._v(" "), _c('footer', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "label-box"
  }, [_c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AboutUs'
        });
      }
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AdCooperation'
        });
      }
    }
  }, [_vm._v("广告合作")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/EliteRecruitment'
        });
      }
    }
  }, [_vm._v("精英招聘")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/Feedback'
        });
      }
    }
  }, [_vm._v("意见反馈")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/TermsOfUse'
        });
      }
    }
  }, [_vm._v("使用条款")]), _vm._v(" "), _c('label', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/ContactUs'
        });
      }
    }
  }, [_vm._v("联系我们")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px",
      "line-height": "1.5",
      "color": "#7d90a0"
    }
  }, [_vm._v("\n          金汇资讯 海南省瑞圣科技有限公司 版权所有 "), _c('a', {
    staticStyle: {
      "color": "#7d90a0"
    },
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("琼ICP备2024029969号-1")]), _c('br'), _vm._v("\n          Copyright © 2012 - " + _vm._s(new Date().getFullYear()) + " jinhuizixun.com All Rights Reserved\n        ")])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.jpg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://user-v.rs-jinhuizixun.com/"
    }
  }, [_vm._v("用户中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('a', {
    attrs: {
      "href": "/#/Service/"
    }
  }, [_vm._v("私人订制")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b06b24a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 114
// module chunks = 15